var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVtbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.02991 5L4.0218 7.64751H17.9919L19 5H5.02991ZM3.51743 8.97066L2.50933 11.6176H16.4794L17.4875 8.97066H3.51743ZM2.00811 12.9413L1 15.5882H14.9701L15.9776 12.9413H2.00811Z",
    fill: "#009FDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVtbIcon);
export default __webpack_public_path__ + "static/media/vtb-icon.26f6bc1fd458f9954306a6e1aa0efac0.svg";
export { ForwardRef as ReactComponent };